const taxCategories = [
    {
        name: 'General',
        taxCode: '00000',
        description: 'General tax category',
    },
    {
        name: 'Clothing',
        taxCode: '20010',
        description: ' All human wearing apparel suitable for general use',
    },
    {
        name: 'Software as a Service',
        taxCode: '30070',
        description: 'Pre-written software, delivered electronically, but access remotely.',
    },
    {
        name: 'Digital Goods',
        taxCode: '31000',
        description: 'Digital products transferred electronically, meaning obtained by the purchaser by means other than tangible storage media.',
    },
    {
        name: 'Food & Groceries',
        taxCode: '40030',
        description: 'Food for humans consumption, unprepared',
    },
    {
        name: 'Non-Prescription',
        taxCode: '51010',
        description: 'Drugs for human use without a prescription',
    },
    {
        name: 'Prescription',
        taxCode: '51020',
        description: 'Drugs for human use with a prescription',
    },
    {
        name: 'Books',
        taxCode: '81100',
        description: 'Books, printed',
    },
    {
        name: 'Textbook',
        taxCode: '81110',
        description: 'Textbooks, printed',
    },
    {
        name: 'Religious Books',
        taxCode: '81120',
        description: 'Religious books and manuals, printed',
    },
    {
        name: 'Magazines & Subscriptions',
        taxCode: '81300',
        description: 'Periodicals, printed, sold by subscription',
    },
    {
        name: 'Magazine',
        taxCode: '81310',
        description: 'Periodicals, printed, sold individually',
    },
    {
        name: 'Other Exempt',
        taxCode: '99999',
        description: 'Item is exempt',
    },
];

export default taxCategories;
